<div class="container-fluid">
  <h3>PSP Pharmacy Details</h3>
  <div class="card">
    <div class="card-body">
      <div class="row justify-content-between">
        <div class="col-6">
          <label for="pName">Pharmacy Name</label>
          <br>
          <span id="pName">{{ pharmacyDetails?.name }}</span>
        </div>
        <div class="col-6">
          <label for="pAddress">Pharmacy Address</label>
          <br>
          <span id="pAddress">{{ pharmacyDetails?.address }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-header" *ngIf="isSuperAdmin">
      <div class="row">
        <div class="col-12">
          <div class="col-md-3">
            <app-companies-select (companySelected)="changePageId($event)" [defaultCompany]="1" [includeAllPrograms]="false" [designClasses]="'active'"></app-companies-select>
          </div>
        </div>
      </div>
    </div>
    <div class="page-height" [scrollWindow]="true" [infiniteScrollDistance]="1" [infiniteScrollThrottle]="10"
      infinite-scroll>
      <app-table [list]="mappedProductList" [headers]="theadArray" [buttons]="addStockbutton"
        (buttonClicked)="buttonAddStockClicked($event,programId)"></app-table>
    </div>
  </div>

  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-12">
          <app-page-header-selections class="mb-0" [headerSelections]="eligibleHistory" title="History"
            (pageChanged)="changePageIdHistory($event)">
          </app-page-header-selections>
        </div>
      </div>
    </div>
    <div *ngIf="currentHistoryPageId == 1" class="page-height" [scrollWindow]="true" [infiniteScrollDistance]="1"
      [infiniteScrollThrottle]="10" infinite-scroll (scrolled)="onScrollDown()">
      <app-table [list]="mappedRequestHistoryList " [headers]="trequestHistory "></app-table>

    </div>
    <div *ngIf="currentHistoryPageId == 2" class="page-height" [scrollWindow]="true" [infiniteScrollDistance]="1"
      [infiniteScrollThrottle]="10" infinite-scroll (scrolled)="onScrollDown()">
      <app-table [list]="mappedStockHistoryList " [headers]="tstockHistory "></app-table>
    </div>
  </div>
</div>